// extracted by mini-css-extract-plugin
export default {"ctn":"Sec_ctn__I8tM-","wrapper":"Sec_wrapper__OmwLM","left":"Sec_left__Pd4ct","right":"Sec_right__sPCaj"};